import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { enmReservationType } from "../../models/enums/ReservationType";
import _ from 'lodash';
import { Fragment, useEffect } from "react";
import { mdlReservationEntryItem } from "../../models/domain/ReservationEntryItem";
import { mdlCustomer } from "../../models/domain/Customer";
import { SFDynamicObject } from "../../models/ui-models/SFDynamicObject";

type ReservationEntryListProps = {
    reservationEntryList?: mdlReservationEntryItem[];
}

export const ReservationEntryList = (props: ReservationEntryListProps) => {
    const { t } = useTranslation();

    useEffect(() => {

    }, [props.reservationEntryList])

    function groupByAgencyName(reservations: mdlReservationEntryItem[]) {
        var result = reservations.reduce((acc, curr) => {
            const agencyName = curr.agencyName || "Unknown";
            const existingGroup = acc.find(group => group.agencyName === agencyName);

            if (existingGroup) {
                existingGroup.reservations.push(curr);
            } else {
                acc.push({
                    agencyName: agencyName,
                    reservations: [curr]
                });
            }

            return acc;
        }, [] as { agencyName: string; reservations: mdlReservationEntryItem[] }[]);
        return result;
    }

    const getTotalPax = (entryItem: { agencyName: string; reservations: mdlReservationEntryItem[] }, onlyPax: boolean = false) => {
        var adultCount = 0;
        var childCount = 0;
        var infantCount = 0;
        _.each(entryItem.reservations, function (res) {
            adultCount += res.adult!;
            childCount += res.child!;
            infantCount += res.infant!;
        })

        if (!onlyPax)
            return `${adultCount + childCount + infantCount} (${t("pdf.listEntry.adult")} : ${adultCount} ${t("pdf.listEntry.child")} : ${childCount} ${t("pdf.listEntry.infant")} : ${infantCount})`;
        else return adultCount + childCount + infantCount;
    }

    function extractBracketContent(input: string): string | null {
        const match = input.match(/\(([^)]+)\)/);
        return match ? match[1] : null;
    }


    const getTotalRoom = (entryItem: { agencyName: string; reservations: mdlReservationEntryItem[] }) => {
        var rooms: SFDynamicObject = {};
        var totalRoomCount = 0;
        _.each(entryItem.reservations, function (res) {
            const room = extractBracketContent(res.roomName!);
            var requestedRoom = rooms[room!];
            if (requestedRoom) {
                rooms[room!] += res.roomCount;
            }
            else {
                rooms[room!] = res.roomCount;
            }
            totalRoomCount += res.roomCount!;
        })

        var roomStringArray = new Array<string>();
        for (const [key, value] of Object.entries(rooms)) {
            roomStringArray.push(key + " : " + value);
        }

        return `${totalRoomCount} (${roomStringArray.join(" ---- ")})`;
    }

    return (
        <div style={{ marginLeft: "30px" }}>
            {
                props.reservationEntryList
                &&
                groupByAgencyName(props.reservationEntryList!).map((agency: { agencyName: string; reservations: mdlReservationEntryItem[] }, index: number) => (
                    <Fragment key={index}>
                        <div className="root-pdf">
                            <div className={`container-fluid list-entry`} style={{ fontSize: "10px" }}>
                                <div className="row">
                                    <div className="col-2">
                                        <img style={{ width: "160px" }} src={_.first(agency.reservations)?.agencyLogo}></img>
                                    </div>
                                    <div className="col-8 text-center">
                                        <div className="col-12">
                                            <h4>{agency.agencyName}</h4>
                                        </div>
                                        <div className="col-12">
                                            <h4>{_.first(agency.reservations)?.hotelName}</h4>
                                        </div>
                                        <div className="col-12">
                                            <h4>{t("pdf.listEntry.pdfTitle")}</h4>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="col-12">
                                            {t("pdf.listEntry.exportDate")} : {dayjs().format("DD.MM.YYYY")}
                                        </div>
                                        <div className="col-12">
                                            {t("pdf.listEntry.exportHour")} :  {dayjs().format("HH:MM")}
                                        </div>
                                    </div>
                                </div>

                                <div className="entry-area row">
                                    <div className="row table-wrap mb-table">
                                        <table className="table-responsive table-borderless upper-table">
                                            <thead>
                                                <tr className="bottom-border">
                                                    <th style={{ width: "6%" }}>{t("pdf.listEntry.operator")}</th>
                                                    <th style={{ width: "6%" }}>{t("pdf.listEntry.voucher")}</th>
                                                    <th style={{ width: "16%" }}>{t("pdf.listEntry.accom")}</th>
                                                    <th style={{ width: "6%" }}>{t("pdf.listEntry.day")}</th>
                                                    <th style={{ width: "6%" }}>{t("pdf.listEntry.roomCount")}</th>
                                                    <th style={{ width: "10%" }}>{t("pdf.listEntry.room")}</th>
                                                    <th style={{ width: "16%" }}>{t("pdf.listEntry.roomType")}</th>
                                                    <th style={{ width: "6%" }}>{t("pdf.listEntry.accomType")}</th>
                                                    <th style={{ width: "6%" }}>{t("pdf.listEntry.status")}</th>
                                                    <th style={{ width: "8%" }}>{t("pdf.listEntry.sellDate")}</th>
                                                </tr>

                                            </thead>
                                            {
                                                agency.reservations.map((entryData: mdlReservationEntryItem, entryIndex: number) => (
                                                    <Fragment key={entryIndex}>
                                                        <tbody className="pdf-safe-break">
                                                            <tr>
                                                                <td>{entryData.operator}</td>
                                                                <td>{entryData.voucher}</td>
                                                                <td>{dayjs(entryData.checkInDate).format("DD.MM.YYYY")} - {dayjs(entryData.checkOutDate).format("DD.MM.YYYY")}</td>
                                                                <td>{entryData.night}</td>
                                                                <td>{entryData.roomCount}</td>
                                                                <td>{entryData.roomName}</td>
                                                                <td>{entryData.roomType}</td>
                                                                <td>{entryData.accomType}</td>
                                                                <td>
                                                                    {
                                                                        entryData.status == enmReservationType.New
                                                                        &&
                                                                        <span>{t("pdf.listEntry.statusNew")}</span>
                                                                    }
                                                                    {
                                                                        entryData.status == enmReservationType.Changed
                                                                        &&
                                                                        <span>{t("pdf.listEntry.statusChanged")}</span>
                                                                    }
                                                                    {
                                                                        entryData.status == enmReservationType.Cancelled
                                                                        &&
                                                                        <span>{t("pdf.listEntry.statusCancelled")}</span>
                                                                    }
                                                                </td>
                                                                <td>{dayjs(entryData.sellDate).format("DD.MM.YYYY")}</td>
                                                            </tr>
                                                        </tbody>
                                                        <tbody>
                                                            <tr>
                                                                <th ></th>
                                                                <th ></th>
                                                                <th className="border-bottom" style={{ width: "10%" }}>{t("pdf.listEntry.customerName")}</th>
                                                                <th className="border-bottom" style={{ width: "6%" }}>{t("pdf.listEntry.age")}</th>
                                                                <th className="border-bottom" style={{ width: "10%" }}>{t("pdf.listEntry.birthDate")}</th>
                                                                <th className="border-bottom" style={{ width: "10%" }}>{t("pdf.listEntry.nationality")}</th>
                                                                <th className="border-bottom" style={{ width: "6%" }}>{t("pdf.listEntry.arrival")}</th>
                                                                <th className="border-bottom" style={{ width: "6%" }}>{t("pdf.listEntry.hour")}</th>
                                                                <th className="border-bottom" style={{ width: "6%" }}>{t("pdf.listEntry.departure")}</th>
                                                                <th className="border-bottom" style={{ width: "6%" }}>{t("pdf.listEntry.hour")}</th>
                                                            </tr>
                                                            {

                                                                entryData.customers?.map((customer: mdlCustomer, customerIndex: number) => (
                                                                    <Fragment key={customerIndex}>
                                                                        <tr>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td>{customer.name}</td>
                                                                            <td>{customer.age}</td>
                                                                            <td>{dayjs(customer.birthDate).format("DD.MM.YYYY")}</td>
                                                                            <td>{customer.nationality}</td>
                                                                            <td>{customer.arrival}</td>
                                                                            <td>{dayjs(customer.arrivalTime).format("HH:mm")}</td>
                                                                            <td>{customer.departure}</td>
                                                                            <td>{dayjs(customer.departureTime).format("HH:mm")}</td>
                                                                        </tr>
                                                                    </Fragment>
                                                                ))
                                                            }
                                                        </tbody>
                                                        <tbody className="bottom-border">
                                                            <tr>
                                                                <th colSpan={12}>{t("pdf.listEntry.note")}</th>
                                                            </tr>
                                                        </tbody>
                                                    </Fragment>
                                                ))
                                            }
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="summarise-area" style={{ width: "100%" }}>
                                <h4>{_.first(agency.reservations)?.hotelName} {t("pdf.listEntry.total")}</h4>
                                <hr />
                                <div className="row">
                                    <div className="col-8">
                                        <span>{t("pdf.listEntry.totalPax")} : {getTotalPax(agency)}</span>
                                    </div>
                                    <div className="col-8">
                                        <span>{t("pdf.listEntry.totalRoom")} : {getTotalRoom(agency)}</span>
                                    </div>
                                </div>
                                <h4>{t("pdf.listEntry.totalPax")} : {getTotalPax(agency, true)} </h4>
                            </div>
                        </div>
                    </Fragment>
                ))
            }
        </div>
    )
}